import { defineStore } from "pinia";
import { taskService } from "@/_services";

export const taskStore = defineStore("task", {
  state: () => ({
    tasks: null,
    tasksExport: null,
    task: null,
    unloadCandidates: null,
    loadCandidates: null,
    locationHistories: null,
    error: null,
  }),

  actions: {
    clear() {
      this.tasks = null;
      this.tasksExport = null;
      this.task = null;
      this.unloadCandidates = null;
      this.loadCandidates = null;
      this.locationHistories = null;
      this.error = null;
    },
    getUnloadCandidates(routeId) {
      this.error = null;
      this.unloadCandidates = null;
      return taskService
        .getUnloadCandidates(routeId)
        .then((result) => {
          this.unloadCandidates = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getLoadCandidates(routeId) {
      this.error = null;
      this.loadCandidates = null;
      return taskService
        .getLoadCandidates(routeId)
        .then((result) => {
          this.loadCandidates = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getLocationHistoryQl(query, sort) {
      this.error = null;
      this.locationHistories = null;
      return taskService
        .getLocationHistoryQl(query, sort)
        .then((result) => {
          this.locationHistories = result.data;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getTaskById(taskId) {
      this.task = null;
      this.error = null;
      return taskService
        .getTaskById(taskId)
        .then((result) => {
          this.task =  result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getTasks(pagination, query, sort) {
      this.error = null;
      taskService
        .getTasks(pagination, query, sort)
        .then((result) => {
          this.tasks = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.tasksExport = null;
      return taskService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.tasksExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
  },
});
